import React from "react";
import CardVisibleSide from "./CardVisibleSide";
import {useSelector} from "react-redux";


const PreSelectionCard = ({cardFlipHandler, id, extThumbnail, intThumbnail, descKrExt, descEnExt, descKrInt, descEnInt, nameKr, nameEn, cardFlipToggle, selectDefaultOption}) => {
  const langData = useSelector(state => state.theme.langData);
  const currentVehicle = useSelector(state => state.optionWindow.currentVehicle);



  return (
    <div className="card card-flip" data-cardflip={cardFlipToggle.includes(id)}>
      <div className="toggle-flip" onClick={cardFlipHandler ? () => cardFlipHandler(id) : null}></div>
      <div className="card-inner">
        <CardVisibleSide callBack={() => selectDefaultOption(currentVehicle.id, id)}
                         image={extThumbnail} cardSide={"front"}
                         name={langData === "kr" ? nameKr : nameEn}
                         desc={langData === "kr" ? descKrExt : descEnExt}
         />
        <CardVisibleSide callBack={() => selectDefaultOption(currentVehicle.id, id)}
                         image={intThumbnail} cardSide={"back"}
                         name={langData === "kr" ? nameKr : nameEn}
                         desc={langData === "kr" ? descKrInt : descEnInt}
        />
      </div>
    </div>)
}

export default PreSelectionCard;
